import React from 'react';

const ErrorComponent = ({ errorMessage }) => {
  return <div className="text-red-500 font-header1 text-center">{errorMessage}</div>;
};

export default ErrorComponent;
